import { useContext } from "react";
import { useQuery } from "react-query";
import { AuthContext } from "../../../../Context/AuthContext";

const GetProductById = (identifier) => {
  const { token } = useContext(AuthContext);

  const fetchProduct = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/product/products/${encodeURIComponent(identifier)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch product");
    }

    return response.json();
  };

  const { data, isLoading, isError, refetch } = useQuery(
    ["productDetails", identifier],
    fetchProduct,
    { enabled: !!identifier }
  );

  return { data, isLoading, isError, refetch };
};

export default GetProductById;
